var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_471",
    "data-name": "Gruppe 471",
    transform: "translate(21 47.6) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_36",
    "data-name": "Pfad 36",
    d: "M19.616,0,9.81,9.814,0,0",
    transform: "translate(2.984 17.398)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_374",
    "data-name": "Pfad 374",
    d: "M0,27.21V0",
    transform: "translate(12.792 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4d5cac6769cb49f426f09bbae8feff40.svg";
export { ForwardRef as ReactComponent };